import { TFunction } from "i18next";
import * as yup from "yup";


export interface ProgramRequestInstitutionSearchValidationSchemeProps {
    t: TFunction;
}

export const ProgramRequestInstitutionSearchValidationScheme = ({
  t,
}: ProgramRequestInstitutionSearchValidationSchemeProps) => {
  
  const dateFromLessThanDateTo = t("validations.dateFromLessThanDateTo");
  return yup.object().shape({
    dateFrom: yup.date().nullable().when("dateTo", (dateTo, schema) => {
      if (dateTo) {
        return yup.date().nullable().max(dateTo, dateFromLessThanDateTo)
      } else {
        return schema;
      }
    })
  })
};